import axiosInstance from '../../common/axios.service';
import {UPDATE_CONFIG} from './organisationConfig.type';

const getOrganisationConfig = () => {
  return axiosInstance.get('config/listOrganisationConfig').then((response) => {
    return response;
  });
};

const updateOrganisationConfig = (values: UPDATE_CONFIG) => {
  return axiosInstance.put('config/updateOrganisationConfig', values).then((response) => {
    return response;
  });
};

const reloadConfig = () => {
  return axiosInstance.get('config/reloadMyOrganisationConfig_batswapef').then((response) => {
    return response;
  });
};

const organisationConfigService = {
  getOrganisationConfig,
  updateOrganisationConfig,
  reloadConfig,
};

export default organisationConfigService;
